/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        Request.js
//   Object:     Request
//   Details:    Request store
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 101879 02/07/19 JC  M01  Can now copy from another request
//  84474 26/09/19 JC  M02  Need to URI encode the site
// 115164 12/10/21 JC  M03JC	Added day parts, hours
// WI2232 25/01/23 JC  M04JC	Added SpecificDays
// WI4743 24/02/25 JC  M05JC	Pass date to API on get one
//-------------------------------------------------------
*/

import { history } from '../history';
import { fetchActions } from "../FetchWrapper";
import { userActions } from './Authentication';
import { requestTypes } from '../constants/RequestTypes';
import { utils } from '../utils/utils';
import { planActions } from './MyPlan';

const requestGetRequestType = 'REQUEST_GET_REQUEST';
const requestGetSuccessType = 'REQUEST_GET_SUCCESS';
const requestGetFailureType = 'REQUEST_GET_FAILURE';

const requestSaveRequestType = 'REQUEST_SAVE_REQUEST';
const requestSaveSuccessType = 'REQUEST_SAVE_SUCCESS';
const requestCheckSuccessType = 'REQUEST_CHECK_SUCCESS';
const requestSaveFailureType = 'REQUEST_SAVE_FAILURE';

const requestAckOrCancelRequestType = 'REQUEST_ACK_OR_CANCEL_REQUEST';
const requestAckOrCancelSuccessType = 'REQUEST_ACK_OR_CANCEL_SUCCESS';
const requestAckOrCancelFailureType = 'REQUEST_ACK_OR_CANCEL_FAILURE';

const requestCheckClearType = 'REQUEST_CHECK_CLEAR';
const requestFromCalendar = 'REQUEST_FROM_CALENDAR';

const requestCopyAcknowledge = 'REQUEST_COPYACKNOWLEDGE'; //M01 

const initialState = {
	request: undefined,
	isLoading: false,
	error: undefined,
	checkResponse: undefined,
	fromCalendar: undefined,
	copyAcknowledge: false //M01
};

export const requestActions = {
	get,
	save,
	check,
	clearCheck,
	acknowledge,
	cancel,
	setFromCalendar,
	setCopyAcknowledge //M01
};

function get(id, date, copyfromid) {
	return (dispatch, getState) => {
		if (!getState().clientConfiguration.isLoaded)
			return;

		if (!getState().clientConfiguration.config.endpoint && !getState().authentication.user)
			return;

		dispatch(_request());

		const url = getState().clientConfiguration.config.endpoint + "/requests/" + id;
		var query = `?copyfromid=${copyfromid}`; //M01 build up a query string, passing in the copy from id
		//M05JC pass the date to the API if we have one
		if (date && date !== "0") {
			query = query + `&requestdate=${utils.truncateDate(date)}`;
		}

		const ticket = getState().authentication.user.ticket;

		fetchActions.get(url + query, ticket) //M01 add the query to the URL
			.then(
				response => {
					if (+id === 0 && date && date !== "0") {//M01 check we've not been passed a null date
						response.data.fromDate = utils.truncateDate(date);
						response.data.toDate = utils.truncateDate(date);
					}
					else {
						response.data.fromDate = utils.truncateDate(response.data.fromDate);
						response.data.toDate = utils.truncateDate(response.data.toDate);
					}
					response.data.timestamp = Date.now();

					dispatch(_success(response.data));
				},
				error => {
					if (error.sessionExpired) {
						dispatch(userActions.sessionExpired());
					}
					else {
						var message = `Could not get request: ${error.message}`;
						dispatch(_failure(message));
					}
				}
			);
	};

	function _request() { return { type: requestGetRequestType }; }
	function _success(request) { return { type: requestGetSuccessType, request }; }
	function _failure(error) { return { type: requestGetFailureType, error }; }
}


function save(id, requestTypeId, absenceReasonId, fromDate, toDate, isSpecificDays, specificDays,
			  sites, requestNote, dayPart, hours) { //M03JC
	return saveOrCheck(id, requestTypeId, absenceReasonId, fromDate, toDate, isSpecificDays, specificDays,
					   sites, requestNote, dayPart, hours, false); //M03JC M04JC
}

function check(id, requestTypeId, absenceReasonId, fromDate, toDate, isSpecificDays, specificDays,
			   sites, requestNote, dayPart, hours) { //M03JC
	return saveOrCheck(id, requestTypeId, absenceReasonId, fromDate, toDate, isSpecificDays, specificDays,
					   sites, requestNote, dayPart, hours, true); //M03JC M04JC
}

function saveOrCheck(id, requestTypeId, absenceReasonId, fromDate, toDate, isSpecificDays, specificDays,
	sites, requestNote, dayPart, hours, check) { //M03JC M04JC
	return (dispatch, getState) => {
		if (!getState().clientConfiguration.isLoaded)
			return;

		if (!getState().clientConfiguration.config.endpoint && !getState().authentication.user)
			return;

		dispatch(_request());

		const url = getState().clientConfiguration.config.endpoint + "/requests?checkHoliday=" + check;
		const ticket = getState().authentication.user.ticket;

		const absenceReasons =
			requestTypeId === requestTypes.absence
				? [{ absenceReasonId, isSelected: true }]
				: [];

		//M04JC build return specific days
		let returnSpecificDays = [];
		if (isSpecificDays) {
			//go through each specific day
			specificDays.forEach(function (specificDay) {
				//and if included
				if (specificDay.isIncluded) {
					//add to the return
					returnSpecificDays.push(specificDay.specificDate);
				}
			});
		}

		const data = {
			id, requestTypeId, absenceReasons, fromDate, toDate, sites, requestNote, dayPart, hours,
			isSpecificDays, specificDays: returnSpecificDays
		}; //M03JC M04JC

		fetchActions.post(url, ticket, data)
			.then(
				response => {
					if (check) {
						dispatch(_checkSuccess(response.data));
					}
					else {
						dispatch(_saveSuccess());
						navigateAwayFromRequest(dispatch, getState);
					}
				},
				error => {
					if (error.sessionExpired) {
						dispatch(userActions.sessionExpired());
					}
					else {
						var message = `Could not ${check ? "check" : "save"} request: ${error.message}`;
						dispatch(_failure(message));
					}
				}
			);
	};

	function _request() { return { type: requestSaveRequestType }; }
	function _saveSuccess() { return { type: requestSaveSuccessType }; }
	function _checkSuccess(checkResponse) { return { type: requestCheckSuccessType, checkResponse }; }
	function _failure(error) { return { type: requestSaveFailureType, error }; }
}

function clearCheck() {
	return (dispatch) => {
		dispatch({ type: requestCheckClearType });
	};
}

function acknowledge(id) {
	return (dispatch, getState) => {

		if (!getState().clientConfiguration.isLoaded)
			return;

		if (!getState().clientConfiguration.config.endpoint && !getState().authentication.user)
			return;

		dispatch(_request());

		const url = getState().clientConfiguration.config.endpoint + "/requests/acknowledge/" + id;
		const ticket = getState().authentication.user.ticket;

		fetchActions.post(url, ticket)
			.then(
				response => {
					dispatch(_success());
					navigateAwayFromRequest(dispatch, getState);
				},
				error => {
					if (error.sessionExpired) {
						dispatch(userActions.sessionExpired());
					}
					else {
						var message = `Could not acknowledge request: ${error.message}`;
						dispatch(_failure(message));
					}
				}
			);
	};

	function _request() { return { type: requestAckOrCancelRequestType }; }
	function _success() { return { type: requestAckOrCancelSuccessType }; }
	function _failure(error) { return { type: requestAckOrCancelFailureType, error }; }
}

function cancel(id) {
	return (dispatch, getState) => {

		if (!getState().clientConfiguration.isLoaded)
			return;

		if (!getState().clientConfiguration.config.endpoint && !getState().authentication.user)
			return;

		dispatch(_request());

		const url = getState().clientConfiguration.config.endpoint + "/requests/cancel/" + id;
		const ticket = getState().authentication.user.ticket;

		fetchActions.post(url, ticket)
			.then(
				response => {
					dispatch(_success());
					navigateAwayFromRequest(dispatch, getState);
				},
				error => {
					if (error.sessionExpired) {
						dispatch(userActions.sessionExpired());
					}
					else {
						var message = `Could not cancel request: ${error.message}`;
						dispatch(_failure(message));
					}
				}
			);
	};

	function _request() { return { type: requestAckOrCancelRequestType }; }
	function _success() { return { type: requestAckOrCancelSuccessType }; }
	function _failure(error) { return { type: requestAckOrCancelFailureType, error }; }
}

function setFromCalendar(fromCalendar) {
	return (dispatch) => {
		dispatch({ type: requestFromCalendar, fromCalendar });
	};
}

//M01 set copy acknowledge
//function setCopyAcknowledge(_copyAcknowledge) {
//    //this.copyAcknowledge = _copyAcknowledge;
//    //const { copyAcknowledge } = getState().request;
//    //copyAcknowledge = true;
//    this.setState({ copyAcknowledge: _copyAcknowledge})
//}

//M01 set copy acknowledge
function setCopyAcknowledge(copyAcknowledge) {
	return (dispatch) => {
		dispatch({ type: requestCopyAcknowledge, copyAcknowledge });
	};
}

function navigateAwayFromRequest(dispatch, getState) {
	const { fromCalendar, copyAcknowledge } = getState().request; //M01 also get copyAcknowledge
	dispatch(planActions.refresh());

	//M01 get the id from the request
	var requestId = getState().request.request.id

	//M01 - if copy acknowledge, push to new, making copy of original
	if (copyAcknowledge) {

		//push back to the history page using a copy request, passing in id of 0 for new, a null date and the request id
		//if attempting to do this without a new private route the page simply doesn't load
		history.push(`/myrequests_copy/detail/0/0/${requestId}`);
	}
	else {
		if (fromCalendar) {
			const { siteId, site, year, month } = fromCalendar;
			history.push(`/myplan/site/${siteId}/${encodeURIComponent(site)}/${year}/${month}`); //M02
		}
		else {
			history.push(`/myrequests`);
		}
	}
}

export const reducer = (state, action) => {
	state = state || initialState;

	// Get request
	if (action.type === requestGetRequestType) {
		return { ...state, isLoading: true, error: undefined };
	}

	if (action.type === requestGetSuccessType) {
		return { ...state, isLoading: false, request: action.request, checkResponse: undefined };
	}

	if (action.type === requestGetFailureType) {
		return { ...state, isLoading: false, error: action.error };
	}

	// Save and check
	if (action.type === requestSaveRequestType) {
		return { ...state, isLoading: true, error: undefined, checkResponse: undefined };
	}

	if (action.type === requestSaveSuccessType) {
		return { ...state, isLoading: false, checkResponse: undefined };
	}

	if (action.type === requestCheckSuccessType) {
		return { ...state, isLoading: false, checkResponse: action.checkResponse };
	}

	if (action.type === requestSaveFailureType) {
		return { ...state, isLoading: false, error: action.error, checkResponse: undefined };
	}

	if (action.type === requestCheckClearType) {
		return { ...state, checkResponse: undefined };
	}

	// Ack or cancel
	if (action.type === requestAckOrCancelRequestType) {
		return { ...state, isLoading: true, error: undefined };
	}

	if (action.type === requestAckOrCancelSuccessType) {
		return { ...state, isLoading: false, error: undefined, checkResponse: undefined };
	}

	if (action.type === requestAckOrCancelFailureType) {
		return { ...state, isLoading: false, error: action.error };
	}

	// From calendar
	if (action.type === requestFromCalendar) {
		return { ...state, fromCalendar: action.fromCalendar };
	}

	// M01 copy acknowledge
	if (action.type === requestCopyAcknowledge) {
		return { ...state, copyAcknowledge: action.copyAcknowledge };
	}

	return state;
};